module.exports = __webpack_public_path__ + "static/media/Andy.b16d7003.png";